import React, { Component } from "react";
import { Link } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { notifyUser } from "../../actions/notify";
import Alert from "../layout/Alert";
import { connect } from "react-redux";
import Spinner from "../layout/Spinner";

class EditQuiz extends Component {
  constructor(props) {
    super(props);

    this.state = {
      codice: "",
      domande: [],
    };
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }
  onSubmit = (e) => {
    const { firestore, history, notifyUser, quiz } = this.props;
    e.preventDefault();
    const editQuiz = {
      codice: this.state.codice ? this.state.codice : quiz.codice,
      tipo: this.state.tipo ? this.state.tipo : quiz.tipo,
      disponibile: this.state.disponibile ? this.state.disponibile.toLowerCase() === "true" ? true : false : quiz.disponibile
    };
    firestore
      .set({ collection: "quiz", doc: this.props.match.params.id }, editQuiz, {merge: true})
      .catch((e) => {
        notifyUser(e.message, "error");
        setTimeout(() => notifyUser(null, null), 4000);
      })
      .then(() => history.push("/"));
  };
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheckbox(e) {
    const item = e.target.name;
    const {firestore, quiz} = this.props;
    if (e.target.checked) {
        firestore.update(
            { collection: "quiz", doc: this.props.match.params.id },
            { domande: quiz.domande.concat([e.target.name]) }
          );
      this.setState((prevState) => prevState.domande.push(parseFloat(item)));
    } else {
        firestore.update(
            { collection: "quiz", doc: this.props.match.params.id },
            {
              domande: quiz.domande.filter(function (val) {
                return val !== e.target.name;
              }),
            }
          );
      this.setState((prevState) => prevState.domande.pop(parseFloat(item)));
    }
  }
  render() {
    const { domande, quiz } = this.props;
    const { message, messageType } = this.props.notify;
    if (domande) {
      return (
        <div>
          <div className='row'>
            <div className='col-md-6'>
              <Link to='/quiz' className='btn btn-link'>
                <i className='fas fa-arrow-circle-left' /> Indietro alla
                lista quiz
              </Link>
            </div>
          </div>
          {message ? (
            <Alert message={message} messageType={messageType} />
          ) : null}
          <div className='card'>
            <h5 className='card-header'>Modifica Quiz</h5>
            <div className='card-body'>
              <form onSubmit={this.onSubmit}>
                <div className='row'>
                  <div className='col-md-4'>
                    <div className='form-group'>
                      <label htmlFor='codice'>Codice</label>
                      <input
                        type='text'
                        className='form-control'
                        name='codice'
                        id='codice'
                        required
                        onChange={this.onChange}
                        defaultValue={
                            quiz.id === this.props.match.params.id
                              ? quiz.codice
                              : null
                          }
                      />
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='form-group'>
                      <label htmlFor='tipo'>Tipo</label>
                      <select
                      className='form-control'
                      name='tipo'
                      id='tipo'
                      onChange={this.onChange}
                      defaultValue={
                        quiz.id === this.props.match.params.id
                          ? quiz.tipo
                          : null
                      }
                      key={quiz.id === this.props.match.params.id
                        ? quiz.tipo
                        : null}
                      required
                    >
                      <option value='default'>Seleziona Tipo...</option>
                      <option value='Esercitazione'>Esercitazione</option>
                      <option value='Esame'>Esame</option>
                    </select>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='form-group'>
                      <label htmlFor='disponibile'>Disponibile</label>
                      <select
                      className='form-control'
                      name='disponibile'
                      id='disponibile'
                      onChange={this.onChange}
                      defaultValue={
                        quiz.id === this.props.match.params.id
                          ? quiz.disponibile
                          : null
                      }  
                      key={quiz.id === this.props.match.params.id
                        ? quiz.disponibile
                        : null}
                      required
                    >
                      <option value='default'>Seleziona Tipo...</option>
                      <option value={true}>Si</option>
                       <option value={false}>No</option>
                    </select>
                    </div>
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-stripped '>
                      <thead className='thead-inverse'>
                        <tr>
                          <th>Numero</th>
                          <th>Regola</th>
                          <th>Tipo</th>
                          <th className='text-center'>Domande selezionate: {quiz.domande.length}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {domande.map((domanda) => (
                          <tr key={domanda.id}>
                            <td>{domanda.numero}</td>
                            <td>{domanda.regola}</td>
                            <td>{domanda.tipo}</td>
                            <td className='text-center'>
                              <input
                                type='checkbox'
                                name={domanda.numero}
                                id={domanda.id}
                                onChange={this.handleCheckbox}
                                defaultChecked={
                                    quiz.id === this.props.match.params.id
                                      ? quiz.domande.includes(domanda.numero)
                                        ? true
                                        : false
                                      : null
                                  }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <input
                  type='submit'
                  className='btn btn-primary btn-block'
                  value='Invia'
                />
              </form>
            </div>
          </div>
        </div>
      );
    } else {
      return <Spinner />;
    }
  }
}

export default compose(
  firestoreConnect((props) => [
    {
      collection: "domande",
      orderBy: 'regola'
    },
  ]),
  firestoreConnect((props) => [
    {
      collection: "quiz",
      doc: props.match.params.id
    },
  ]),
  connect(
    (state, props) => ({
      domande: state.firestore.ordered.domande,
      quiz: state.firestore.ordered.quiz && state.firestore.ordered.quiz[0],
      notify: state.notify,
    }),
    { notifyUser }
  )
)(EditQuiz);
